import React, { FC, forwardRef } from 'react';
import { SwitchProps } from './types';
import {
  InputStyle,
  ThumbStyle,
  LabelStyle,
  CheckedNode,
  UnCheckedNode,
} from './styles';

const Switch: FC<SwitchProps> = forwardRef<HTMLInputElement, SwitchProps>(({
  checked,
  onChange,
  innerCheckedNode,
  innerUnCheckedNode,
  icon,
  ...restProps
}, ref) => {
  return (
    <LabelStyle
      htmlFor='switch-label'
      checked={checked}
      {...restProps}
    >
      <ThumbStyle
        checked={checked}
      >
        {icon}
      </ThumbStyle>
      <InputStyle
        type='checkbox'
        id='switch-label'
        checked={checked}
        onChange={onChange}
        ref={ref}
        {...restProps}
      />
      { checked &&
        <CheckedNode>
          {innerCheckedNode}
        </CheckedNode>
      }
      { !checked &&
        <UnCheckedNode>
          {innerUnCheckedNode}
        </UnCheckedNode>
      }
    </LabelStyle>
  );
});

export default Switch;
